/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_X_Offset_LabelInputs */



/**
* | output |
* | --- |
* | "X-Offset" |
*
* @param {Video_Filters_X_Offset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_x_offset_label = /** @type {((inputs?: Video_Filters_X_Offset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_X_Offset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decalage X")
	if (locale === "de") return /** @type {LocalizedString} */ ("X-Offset")
	if (locale === "it") return /** @type {LocalizedString} */ ("X-Offset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("X-смещение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazamiento X")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("X轴偏移")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Xオフセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक्स-ऑफसेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocamento X")
	return /** @type {LocalizedString} */ ("X-Offset")
});